const partnersFields = ['name', 'homeLink', 'shortName', 'classLogo', 'logo'];

const exported = {
  fields: ['s12nId'],

  includes: {
    progress: {
      fields: ['lastActiveAt', 'lastActiveCourseId', 'certificateMetadata', 'isEligibleForCapstone'],
    },
    signatureTrackProfile: {
      fields: ['firstName', 'middleName', 'lastName'],
    },
    specialization: {
      fields: ['name', 'shortName', 'details', 'interchangeableCourseIds', 'metadata'],
      includes: {
        partners: {
          fields: partnersFields,
        },
        courses: {
          fields: ['name', 'startDate', 'durationString', 'partnerLogo', 'workload'],
          includes: {
            courseProgress: {},
            instructors: {
              fields: [
                'prefixName',
                'firstName',
                'middleName',
                'lastName',
                'suffixName',
                'fullName',
                'shortName',
                'profileId',
              ],
            },
            memberships: {
              fields: ['role', 'courseId', 'enrolledTimestamp', 'lastAccessedTimestamp', 'grade', 'v1SessionId'],
              includes: {
                vcMembership: {
                  fields: ['certificateCode', 'grade', 'grantedAt'],
                },
                signatureTrackProfile: {
                  fields: ['firstName', 'middleName', 'lastName'],
                },
              },
            },
            partners: {
              fields: partnersFields,
            },
            details: {
              fields: ['name', 'shortName'],
              includes: {
                sessions: {
                  fields: [
                    'active',
                    'courseId',
                    'dbEndDate',
                    'durationString',
                    'eligibleForCertificate',
                    'hasSigTrack',
                    'certificatesReleased',
                    'homeLink',
                    'instructorIds',
                    'startDay',
                    'startMonth',
                    'startYear',
                    'status',
                    'v1VcDetailId',
                  ],
                },
              },
            },
          },
        },
      },
    },
  },
};

export default exported;

export const { fields, includes } = exported;
